export * from './src/sortablejs.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-sortablejs/dist/index.js
// module id = 722
// module chunks = 22